var _rect, _path, _path2, _path3, _path4, _path5, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.41 20.704V16.79h2.02c.827 0 1.526-.277 2.095-.824l.137-.139a2.817 2.817 0 00-.137-3.943 2.882 2.882 0 00-2.095-.84h-3.242v9.659h1.222zm0-5.1v-3.373h2.05c.441 0 .859.17 1.17.478.66.647.676 1.725.038 2.395a1.587 1.587 0 01-1.207.5h-2.05zm9.954-.993c-.524-.485-1.238-.732-2.141-.732-1.162 0-2.035.432-2.612 1.287l1.078.685c.395-.585.934-.878 1.617-.878.433 0 .85.162 1.177.455.319.277.501.677.501 1.101v.285c-.47-.262-1.063-.4-1.792-.4-.85 0-1.533.2-2.042.608-.509.408-.767.948-.767 1.633-.015.624.25 1.217.721 1.618.479.43 1.086.647 1.8.647.843 0 1.51-.378 2.02-1.133h.052v.917h1.17v-4.075c0-.855-.259-1.533-.782-2.018zm-3.318 4.876a1.004 1.004 0 01-.402-.809c0-.362.167-.662.493-.901.334-.239.752-.362 1.245-.362.684-.008 1.215.146 1.595.454 0 .524-.205.979-.607 1.364-.365.37-.858.577-1.375.577a1.479 1.479 0 01-.949-.323zm6.727 4.12l4.084-9.512h-1.329l-1.89 4.745h-.023l-1.936-4.745h-1.328l2.68 6.185-1.519 3.328h1.26z",
    fill: "#3C4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.19 15.944c0-.378-.03-.755-.09-1.125h-5.156v2.134h2.954a2.571 2.571 0 01-1.094 1.687v1.386h1.762c1.032-.963 1.624-2.387 1.624-4.082z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.945 21.366c1.473 0 2.718-.493 3.621-1.34l-1.761-1.386c-.494.338-1.124.53-1.86.53-1.428 0-2.635-.977-3.068-2.287H7.063v1.433a5.452 5.452 0 004.882 3.05z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.877 16.883a3.392 3.392 0 010-2.125v-1.425H7.063a5.57 5.57 0 000 4.975l1.814-1.425z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.945 12.47a2.92 2.92 0 012.095.832l1.564-1.587a5.235 5.235 0 00-3.66-1.44c-2.064 0-3.955 1.186-4.881 3.058l1.814 1.432c.433-1.317 1.64-2.295 3.068-2.295z",
    fill: "#EA4335"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#F2F4F7"
  })));
}
export default SvgGooglePay;